import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockMath } from 'react-katex';
import { evaluate } from 'mathjs';

import SEO from '../../../seo';

const CalculatorActivity = ({ formula, colorId, onClose }) => {
    const { t } = useTranslation();

    const [inputs, setInputs] = useState({});
    const [result, setResult] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    useEffect(() => {
        if (!formula || !formula.calculator) return;
        const allFilled = formula.calculator.variableNames.every(
            (varName) => inputs[varName] !== undefined && inputs[varName] !== ''
        );
        setIsReady(allFilled);
    }, [inputs, formula]);

    if (!formula || !formula.calculator) return null;

    const { variableNames, variablesMap } = formula.calculator;
    const descriptions = formula.content.variables || [];

    const handleInputChange = (varName, value) => {
        const cleanValue = value.replace(',', '.');
        setInputs((prev) => ({ ...prev, [varName]: cleanValue }));
        setResult(null);
    };

    const calculateResult = () => {
        try {
            let mathExpression = variablesMap;
            const sortedVariables = [...variableNames].sort((a, b) => b.length - a.length);

            sortedVariables.forEach((varName) => {
                const escapedVarName = varName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedVarName, 'g');
                mathExpression = mathExpression.replace(regex, `(${inputs[varName]})`);
            });

            const calcAnswer = evaluate(mathExpression);
            setResult(Number(calcAnswer.toFixed(4)));
        } catch (error) {
            console.error("Ошибка вычисления:", error);
            setResult('Ошибка');
        }
    };

    const resultVariableName = descriptions.length > 0 ? descriptions[descriptions.length - 1] : 'Результат';
    const resultColorIndex = (descriptions.length - 1) % 10;

    return (
        <div className="calc-modal-overlay" onClick={onClose}>
            <SEO>
                <title>{`${t('translate.calc_name')}: ${formula.content.formulaName}`}</title>
            </SEO>

            <div className="calc-modal" onClick={(e) => e.stopPropagation()}>
                <button className="calc-modal__close" onClick={onClose}>×</button>

                {/* БЛОК С ФОРМУЛОЙ НА ЦВЕТНОМ ФОНЕ */}
                <div className={`calc-modal__latex-view calc-modal__latex-view--${colorId || 0}`}>
                    {formula.content.formula ? (
                        <BlockMath math={formula.content.formula} />
                    ) : (
                        <span>Формула отсутствует</span>
                    )}
                </div>

                <div className="calc-modal__body">
                    {/* БЛОК ИНПУТОВ (КАЛЬКУЛЯТОР) */}
                    {variableNames.map((varName, index) => {
                        const label = descriptions[index] || varName;
                        const lineColorClass = `calc-color-${index % 10}`;

                        return (
                            <div key={varName} className={`calc-input-group ${lineColorClass}`}>
                                <div className="calc-input-line" />

                                <div className="calc-input-content">
                                    <label className="calc-input-label">{label}</label>
                                    <input
                                        type="number"
                                        className="calc-input-field"
                                        placeholder={label}
                                        value={inputs[varName] || ''}
                                        onChange={(e) => handleInputChange(varName, e.target.value)}
                                    />
                                </div>
                            </div>
                        );
                    })}

                    {/* ВЫВОД РЕЗУЛЬТАТА */}
                    {result !== null && (
                        <div className="calc-item-answer">

                            <div className="calc-item-answer__top">
                                <div className={`calc-item-answer__circle calc-bg-color-${resultColorIndex}`} />
                                <span className="calc-item-answer__title">
                                    {t('translate.calc_answer_title') || 'Ответ'}
                                </span>
                            </div>

                            <div className="calc-item-answer__body">
                                <div className="calc-item-answer__variable">{resultVariableName}</div>
                                <div className="calc-item-answer__value">{result}</div>
                            </div>
                        </div>
                    )}

                    {/* КНОПКА ПОСЧИТАТЬ */}
                    <button
                        className={`calc-submit-btn calc-btn-color-${colorId || 0} ${!isReady ? 'calc-submit-btn--disabled' : ''}`}
                        onClick={calculateResult}
                        disabled={!isReady}
                    >
                        {isReady
                            ? (t('translate.calc_answer_btn') || 'ПОСЧИТАТЬ').toUpperCase()
                            : (t('translate.calc_answer_btn_error') || 'ВВЕДИТЕ ДАННЫЕ').toUpperCase()}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CalculatorActivity;